(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jolie-calendar"] && !Shopify.designMode) return;
  try {
    
//console.log('Shopify designMode:', window.Shopify && window.Shopify.designMode);

//document.addEventListener('DOMContentLoaded', function() {

(function() {
  var CALENDAR_ID = 'monika.vargahu@gmail.com';
  var API_KEY = 'AIzaSyCnA0D5RFq--X-XsrE-N6CEFA5Nb4N5M_Y';

  var WORK_HOURS = {
    0: null,
    1: null,
    2: {start: 8, end: 20},
    3: {start: 8, end: 20},
    4: {start: 8, end: 20},
    5: {start: 8, end: 20},
    6: {start: 8, end: 14}
  };

  var RED = '#E5393585';
  var GREEN = '#4CAF5085';
  var BLUE = '#1E88E585';

  var IT_DAYS_FULL = ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'];
  var IT_MONTHS = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function getDays() {
    var days = [];
    var today = new Date();
	//today.setHours(0, 0, 0, 0);
//  for (var i = 0; i < 28; i++) {
  for (var i = 0; i < DAYS_AHEAD; i++) {
      var d = new Date(today);
      d.setDate(today.getDate() + i);
      days.push(d);
    }
    return days;
  }

  function isBusy(events, day, hour) {
    var slotStart = new Date(day);
    slotStart.setHours(hour, 0, 0, 0);
    var slotEnd = new Date(day);
    slotEnd.setHours(hour + 1, 0, 0, 0);
    for (var i = 0; i < events.length; i++) {
      var eStart = new Date(events[i].start.dateTime || events[i].start.date);
      var eEnd = new Date(events[i].end.dateTime || events[i].end.date);
      if (eStart < slotEnd && eEnd > slotStart) return true;
    }
    return false;
  }

  function buildTable(events) {
    var days = getDays();
    var allHours = [];
    for (var h = 8; h < 20; h++) allHours.push(h);

    var html = '<table>';
    html += '<thead><tr><th></th>';
    days.forEach(function(d) {
      html += '<th><span style="color:#111;">' + d.getDate() + ' ' + IT_MONTHS[d.getMonth()] + '</span><br>' + IT_DAYS_FULL[d.getDay()] + '</th>';
    });
    html += '</tr></thead><tbody>';

    allHours.forEach(function(h) {
      html += '<tr>';
      html += '<td class="time-cell">' + pad(h) + ':00</td>';
      days.forEach(function(d) {
        var dow = d.getDay();
        var hours = WORK_HOURS[dow];
        var bg;
        if (!hours || h < hours.start || h >= hours.end) {
          bg = BLUE;
        } else {
          bg = isBusy(events, d, h) ? RED : GREEN;
        }
        html += '<td class="slot" style="background:' + bg + ';"></td>';
      });
      html += '</tr>';
    });
    html += '</tbody></table>';
    document.getElementById('jolie-cal-table').innerHTML = html;
  }

  function load() {
    var now = new Date();
    var weekLater = new Date();
//    weekLater.setDate(now.getDate() + 28);
    weekLater.setDate(now.getDate() + DAYS_AHEAD);
    var url = 'https://www.googleapis.com/calendar/v3/calendars/' +
      encodeURIComponent(CALENDAR_ID) +
      '/events?key=' + API_KEY +
      '&timeMin=' + now.toISOString() +
      '&timeMax=' + weekLater.toISOString() +
      '&singleEvents=true' +
      '&cachebust=' + Date.now();	  //Ezzel a trukkel rakenyszeritjuk a bongeszot, hogy mindig lekerdezze az allapotot es ne a cache-bol vegye!
	  
    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) { buildTable(data.items || []); })
      .catch(function() {
        document.getElementById('jolie-cal-table').innerHTML = '<p style="color:#E53935;">Impossibile caricare i dati. Riprova più tardi.</p>';
      });
  }

  load();
  //cachebust trukk miatt erre mar nincs szukseg, igy nem frissitunk!
  //setInterval(load, 15 * 60 * 1000);   
})();

var acc = document.getElementsByClassName("accordiondate");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    panel.style.display = panel.style.display === "block" ? "none" : "block";
  });
}

// editor módban nyitva
  if (window.Shopify && window.Shopify.designMode) {
    document.querySelector('.panel').style.display = 'block';
  }

  //});



// Ha Shopify editor módban van, nyissa ki automatikusan
/*
if (window.Shopify && window.Shopify.designMode) {
  document.querySelector('.panel').style.display = 'block';
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.Shopify && window.Shopify.designMode) {
    document.querySelector('.panel').style.display = 'block';
  }
});

if (window.Shopify && window.Shopify.designMode) {
  setTimeout(function() {
    document.querySelector('.panel').style.display = 'block';
  }, 500);
}


// Alapból nyitva, editor módban marad nyitva
document.querySelector('.panel').style.display = 'block';

// Csak élő oldalon csukjuk be
if (!window.Shopify || !window.Shopify.designMode) {
  document.querySelector('.panel').style.display = 'none';
}
*/


//console.log('panel elem:', document.querySelector('.panel'));


  } catch(e) { console.error(e); }
})();
})();
